import * as React from 'react';
import { SaleCardSkeleton, SaleCardVariant } from '..';
import { WrappedSaleCard } from '../../HorizontalSaleList/HorizontalSaleList.style';
import { VerticalWrappedSaleCard } from '../../RecommendedForYou/RecommendedForYou.style';

export const saleCardSkeletonList: (
  numberOfSkeletons: number,
  saleCardVariant: SaleCardVariant
) => JSX.Element[] = (numberOfSkeletons, saleCardVariant) => {
  return new Array(numberOfSkeletons)
    .fill(undefined)
    .map((_, i) => <SaleCardSkeleton key={i} variant={saleCardVariant} />);
};

export const saleCardWrappedSkeletonList: (
  numberOfSkeletons: number,
  saleCardVariant: SaleCardVariant
) => JSX.Element[] = (numberOfSkeletons, saleCardVariant) => {
  return new Array(numberOfSkeletons).fill(undefined).map((_, i) => (
    <WrappedSaleCard key={i}>
      <SaleCardSkeleton key={i} variant={saleCardVariant} />
    </WrappedSaleCard>
  ));
};

export const saleCardVerticalWrappedSkeletonList: (
  numberOfSkeletons: number,
  saleCardVariant: SaleCardVariant
) => JSX.Element[] = (numberOfSkeletons, saleCardVariant) => {
  return new Array(numberOfSkeletons).fill(undefined).map((_, i) => (
    <VerticalWrappedSaleCard key={i}>
      <SaleCardSkeleton key={i} variant={saleCardVariant} />
    </VerticalWrappedSaleCard>
  ));
};
